import { useSelector } from "react-redux";
import CounterSellBilling from "../counterSellBilling/counterSellBilling";
import CounterSell from "../counterSell/counterSell";
import Billing from "../updateBills/Billing";
import UpdateBills from "../updateBills/updateBills";

export const ContainerCont=()=>{
  const billerMenuseletec = useSelector((state) => state.reducer.billerMenuseletec);

    return <>
    {billerMenuseletec==0  && <Billing/>}
    {billerMenuseletec!=0  && <CounterSell/>}

    </>
}